<template>
  <div class="footer" ref="mainFooter">
    <div id="footer">
      <div class="footer_top">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <div class="footer_menu" v-html="wpFooterMenu">
                
              </div><!-- here main menu -->
            </div>
          </div>
        </div>
      </div>
      <div class="footer_bottom">
        <div class="container">
          <div class="row">
            <div class="col-12">&copy; 2023 3dvieweronline - All rights reserved</div>
          </div>
        </div>
      </div>
    </div>

    <div id="mobile_menu_sidebar" class="offcanvas offcanvas-start" tabindex="-1"  aria-labelledby="offcanvasLabel">
      <div class="offcanvas-body">
        <a data-bs-toggle="offcanvas" href="#mobile_menu_sidebar"  class="close"></a>
        <div id="mobile_menu" v-html="mobileMenu">
        </div><!-- menu mobile -->
        <div class="main_menu_social mobile">
          <!-- social link -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import commonProps from '../common/common.js'
import axios from 'axios'
const common = new commonProps();
export default {
  name:'footer-component',
  data() {
    return {
      wpFooterMenu:'',
      mobileMenu:''
    }
  },
  mounted() {
    this.getWpMenu()
    window.addEventListener("resize", this.updateFooterPadding);
  },
  unmounted() {
    window.removeEventListener("resize", this.updateFooterPadding);
  },
  methods: {
    getWpMenu() {
      axios .get(`${common.wpApi}footer_menu`)
            .then(result => {
              if (result.data)
                this.wpFooterMenu = result.data
                this.$nextTick( () => {
                  const footerHeight = this.$refs.mainFooter.clientHeight;
                  document.getElementById('app').style.paddingBottom = footerHeight+'px'
                });
            })
      axios .get(`${common.wpApi}header_menu`)
            .then(result => {
              if (result.data)
                this.mobileMenu = result.data
            })
    },
    updateFooterPadding(){
      const footerHeight = this.$refs.mainFooter.clientHeight;
      document.getElementById('app').style.paddingBottom = footerHeight+'px'
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/footer.scss';

</style>